<template>
  <div class="wrapper-overlay">
    <div class="startup-screen" v-if="!is_activating">
      <div class="screen-one">
        <h1 class="greatings" v-if="student_info">
          Hello {{ student_info.first_name + " " + student_info.last_name }}
        </h1>
        <h2 class="school-name">
          Welcome to <span class="bold"> {{ $route.query.name }}</span>
        </h2>
        <h4 class="information">
          A few steps are required to create your profile, use the button below
          to get started
        </h4>
      </div>
      <div class="wizard-option">
        <button @click="activateAccount()" class="btn-get-started">
          <span>Get Started</span>
        </button>
      </div>
    </div>
    <!-- Form -->
    <div class="form-widget" v-else>
      <div class="form-header">
        <h2>Activate Your Account</h2>
      </div>
      <div class="form-body">
        <div class="input-group">
          <label>First Name</label>
          <input v-model="form.first_name" type="text" class="text-input" />
        </div>
        <div class="input-group">
          <label>Last Name</label>
          <input v-model="form.last_name" type="text" class="text-input" />
        </div>
        <div class="input-group">
          <label>Email</label>
          <input v-model="form.email" type="text" class="text-input" />
        </div>
        <div class="input-group">
          <label>Create Password</label>
          <input v-model="form.password" type="password" class="text-input" />
        </div>
        <div class="input-group">
          <label>Confirm Password</label>
          <input v-model="form.re_password" type="password" class="text-input" />
        </div>
      </div>
      <div class="chech-box">
        <input type="checkbox" id="check" v-model="check" />
        <label for="check" style="margin-right: 3px">Accept</label>
        <label class="colored" @click="showTerms = !showTerms">Terms & Conditions</label>
      </div>

      <div class="form-footer">
        <c-button :loading="submit_loading" @click="submitAccount()" class="btn-save">Proceed</c-button>
      </div>

      <label class="sign-in-up-option">Or Activate Your Account with</label>
      <ul class="social-media-list">
        <li class="linkedin">
          <a @click.prevent="signUpBySocial('linkedin')">
            <img src="@/assets/icons/linkedin.svg" alt />
            <span>Linked In</span>
          </a>
        </li>
        <li class="divider"></li>
        <li class="google">
          <a @click.prevent="signUpBySocial('google')">
            <img src="@/assets/icons/google.svg" alt />
            <span>Google</span>
          </a>
        </li>
        <li class="divider"></li>
        <li class="facebook">
          <a @click.prevent="signUpBySocial('facebook')">
            <img src="@/assets/icons/facebook.svg" alt />
            <span>Facebook</span>
          </a>
        </li>
        <li class="divider"></li>
        <li class="microsoft">
          <a @click.prevent="signUpBySocial('microsoft')">
            <img src="@/assets/icons/microsoft.svg" width="20" alt />
            <span>Microsoft</span>
          </a>
        </li>
      </ul>
    </div>
    <!-- Terms and Condition-->
    <div class="terms-conditions" v-show="showTerms">
      <div class="widget-body">
        <div class="info-panel">
          <button class="back-btn" @click="showTerms = false">
            <img src="../assets/icons/back__ic.svg" />
            <span>Back</span>
          </button>
          <terms-widget />
          <div class="bottom">
            <button class="__transparent" @click="showTerms = false">
              Back
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TermsWidget from "@/components/TermsWidget.vue";
export default {
  name: "invitation-wizard",
  components: {
    TermsWidget
  },
  data() {
    return {
      check: false,
      showTerms: false,
      is_activating: false,
      submit_loading: false,
      form: {
        token: null,
        access_token: "",
        id: null,
        first_name: "",
        last_name: "",
        email: "",
        password: "",
        re_password: "",
      },
      student_info: null,
    };
  },
  watch: {},
  mounted() {
    let vm = this;
    vm.$logOut(false);
    vm.form.token = vm.$route.params.token;
    vm.getUserInfo(vm.form.token);
  },
  methods: {
    getUserInfo(token) {
      let vm = this;
      vm.$store
        .dispatch("GET_SCHOOL_MEMBER_ACCOUNT_INFO", { token: token })
        .then((response) => {
          vm.student_info = response.data;
          vm.form.id = response.data.id;
          vm.form.first_name = response.data.first_name;
          vm.form.last_name = response.data.last_name;
          vm.form.email = response.data.email;
          vm.form.access_token = response.data.access_token;
          vm.$cookies.set("account-type", parseInt(response.data.account_type));
        })
        .catch((error) => { });
    },
    submitAccount() {
      let vm = this;
      if (vm.check) {
        if (vm.form.password === vm.form.re_password) {
          vm.submit_loading = true;
          vm.$store
            .dispatch("STUDENT_SUBMIT_ACCOUNT", vm.form)
            .then((response) => {
              vm.submit_loading = false;
              vm.$notify({
                group: "status",
                type: "success",
                title: "Message",
                text: "Now you can login to your account",
              });
              setTimeout(() => {
                vm.$router.push({ name: "login" });
              }, 2000);
            })
            .catch((error) => {
              vm.submit_loading = false;
              vm.$notify({
                group: "status",
                type: "warn",
                title: "Something wrong",
                text: "Please try again",
              });
            });
        } else {
          vm.$notify({
            group: "status",
            type: "warn",
            title: "Something wrong",
            text: "Password does not match",
          });
        }
      } else {
        vm.$notify({
          group: "status",
          type: "warn",
          title: "Important message",
          text: "Please accept terms and conditions",
        });
      }
    },
    activateAccount() {
      let vm = this;
      vm.is_activating = true;
    },
    signUpBySocial(sign_type) {
      let vm = this;
      sessionStorage.setItem("is_login", false);
      sessionStorage.setItem("isSchoolEnvitation", true);
      sessionStorage.setItem("schoolEnvitationData", JSON.stringify(vm.form));

      vm.loading = true;
      if (sign_type == "linkedin") {
        this.$store
          .dispatch("AUTH_LINKEDIN_SIGNUP_REQUEST", {})
          .then((responce) => {
            vm.loading = false;
          });
      } else if (sign_type == "google") {
        this.$store
          .dispatch("AUTH_GOOGLE_SIGNUP_REQUEST", {})
          .then((responce) => {
            vm.loading = false;
          });
      } else if (sign_type == "facebook") {
        this.$store
          .dispatch("AUTH_FACEBOOK_SIGNUP_REQUEST", {})
          .then((responce) => {
            vm.loading = false;
          });
      } else if (sign_type == "microsoft") {
        this.$store
          .dispatch("AUTH_MICROSOFT_SIGNUP_REQUEST", {})
          .then((responce) => {
            vm.loading = false;
          });
      }
    },
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.wrapper-overlay {
  display: block;
  background: #ededed;
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  overflow-y: auto;

  .startup-screen {
    width: 700px;
    margin: 0 auto;
    margin-top: 200px;
    min-height: 400px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 30px 30px;
    background: #0884af;

    .screen-one {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      .greatings {
        font-size: 37px;
        color: #fff;
      }

      .school-name {
        color: rgb(241, 239, 239);
        font-size: 40px;

        .bold {
          color: #fff;
          font-weight: 900;
        }
      }

      .information {
        color: #e7e7e7;
        padding: 10px 0px;
        font-size: 20px;
        text-align: center;
        margin-bottom: 20px;
      }
    }

    .wizard-option {
      display: flex;
      flex-direction: column;

      .btn-get-started {
        border-radius: 5px;
        color: #1ba5a4;
        background: #fff;
        height: 43px;
        width: 182px;
        margin-bottom: 11px;
      }
    }
  }

  .form-widget {
    width: 500px;
    margin: 0 auto;
    margin-top: 100px;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    padding: 40px 40px;
    background: #fff;

    .form-header {
      padding-bottom: 10px;

      h2 {
        margin: 0px;
        font-weight: 800;
      }
    }

    .form-body {
      display: flex;
      flex-direction: column;
      margin-bottom: 20px;

      .input-group {
        display: flex;
        flex-direction: column;
        margin-block-start: 15px;

        .text-input {
          height: 45px;
          border-radius: 5px;
          border: 1px solid #ddd;
          outline: none;
          padding: 0px 15px;
        }
      }
    }

    .chech-box {
      display: flex;
      align-items: center;
      margin-bottom: 10px;

      #check {
        margin-right: 5px;
      }

      .colored {
        color: #229ea5;
      }
    }

    .form-footer {
      .btn-save {
        border-radius: 5px;
        color: #fff;
        background: #229ea5;
        height: 43px;
        width: 182px;
        margin-bottom: 11px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .social-media-list {
      list-style: none;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      margin-top: 20px;
      padding-left: 0px;

      @media (min-width: 300px) and (max-width: 630px) {
        display: grid;
        grid-template-columns: 48% 48%;
        grid-gap: 10px;
      }

      li {
        &.divider {
          margin-right: 10px;
        }

        a {
          display: flex;
          align-items: center;
          background: #fff;
          padding: 5px 10px;
          border-radius: 10px;
          border: 1px solid #ccc;

          img {
            width: 20px;
          }

          span {
            margin-top: 2px;
            margin-left: 3px;
            color: #000000;
          }

          &:hover {
            background: #ededed;
            color: #fff;
          }
        }
      }
    }

  }

  .terms-conditions {
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;

    .widget-body {
      height: 100%;
      background: #efefef 0% 0% no-repeat padding-box;
      display: flex;
      justify-content: center;
      overflow-y: auto;
      padding-top: 50px;
      padding-bottom: 20px;

      .info-panel {
        background: #ffffff 0% 0% no-repeat padding-box;
        border: 1px solid rgb(226, 226, 226);
        border-radius: 5px;
        width: 800px;
        padding-top: 40px;
        padding-bottom: 20px;
        padding-left: 30px;
        padding-right: 30px;
        display: inline-table;
        position: relative;

        .back-btn {
          position: absolute;
          top: 14px;
          outline: none;
          border: none;
          left: 14px;
          text-decoration: none;
          color: #2991b8;

          span {
            margin-left: 7px;
          }

          img {}
        }

        img.grey_logo {
          margin: 20px 0;
          float: left;
          width: 70px;
          height: 65px;
        }

        img.terms_svg {
          width: 100%;
          display: block;
          margin-top: 20px;
        }

        .bottom {
          margin-top: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;

          button {
            outline: none;
          }

          .__accept {
            font-size: 14px;
            width: 280px;
            height: 25px;
            border-radius: 18px;
            color: #fff;
            background-image: linear-gradient(267deg, #1885ad, #00a3a8);

            outline: none;
            cursor: pointer;
          }

          .__transparent {
            margin-top: 10px;
            color: #2991b8;
          }
        }
      }
    }
  }
}
</style>
